// extracted by mini-css-extract-plugin
module.exports = {"form-group":"RightSidebar_form-group__Tkw8R","container":"RightSidebar_container__DnIhp","containerWithHeader":"RightSidebar_containerWithHeader__11IrU"};